export * from "ce/selectors/aiAssistantSelectors";

import type { DefaultRootState } from "react-redux";
import {
  type AIArtifact,
  AI_ARTIFACT_TYPE as CE_AI_ARTIFACT_TYPE,
  getAIArtifact as CE_getAIArtifact,
} from "ce/selectors/aiAssistantSelectors";
import { IDE_TYPE, type IDEType } from "ee/IDE/Interfaces/IDETypes";
import { getCurrentWorkflowId } from "ee/selectors/workflowSelectors";

export const AI_ARTIFACT_TYPE = {
  ...CE_AI_ARTIFACT_TYPE,
  WORKFLOW: "WORKFLOW",
} as const;

/**
 * Returns the artifact whose editor the user is in. In the workflow editor this is the workflow. A workflow's main
 * code is a JS object, which has no entity id, so the server authorizes those requests against the workflow.
 */
export function getAIArtifact(
  state: DefaultRootState,
  ideType: IDEType,
): AIArtifact {
  if (ideType === IDE_TYPE.Workflow) {
    const workflowId = getCurrentWorkflowId(state);

    return workflowId
      ? { artifactId: workflowId, artifactType: AI_ARTIFACT_TYPE.WORKFLOW }
      : {};
  }

  return CE_getAIArtifact(state, ideType);
}
